import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes.ts';
import useStrategicContext from '@/api/useStrategicContext.ts';

const RequiresOnboardingComplete: FC = () => {
  const { userProfile, isLoadingProfile } = useAuthContext();
  const { data: strategicContext, isLoading: isLoadingContext } = useStrategicContext(userProfile?.org_id);

  if (isLoadingProfile || (!!userProfile?.org_id && isLoadingContext)) return null;

  if (!strategicContext) {
    return <Navigate to={Routes.ONBOARDING} />;
  }

  return <Outlet />;
};

export default RequiresOnboardingComplete;
